import {h, Fragment, Component} from "preact";
import {route} from "preact-router";
import LFeed from "../../../services/live-feed";
import Ticket from "../utils/ticket-logic.jsx";

import * as P from "../mobile-templates/event.jsx";
import {groupMarketsByName} from "./prematch-event.jsx";

import FullSite from "./full-site";
import {LiveTrackerByEventPanel} from "../desktop-components/live-event";

import { 
	LiveEventPage as AwrabetLiveEventPage, 
	TabBasedContent as AwrabetTabBasedContent, 
	LiveEventContent as AwrabetLiveEventContent, 
	CollapsibleMarket as AwrabetCollapsibleMarket 
} from "../../awrabet/mobile-pages/live-event.jsx";

export default function LiveEvent(props) {
	return <FullSite class="bg-slate-300 text-slate-950 dark:bg-transparent dark:text-inherit"><LiveEventPage {...props} /></FullSite>
}

export class LiveEventPage extends AwrabetLiveEventPage {
	render({eventId}) {
		if (LFeed.menu == null)
			return null;
		const event = LFeed.getEvent('/event/'+eventId);
		if (event == null)
			return null; // Torna al menu
		const tournament = LFeed.getTournament(event.parent);
		const sport = LFeed.menu[tournament.parent];
		return <LiveEventContent eventId={event.id} tournament={tournament} sport={sport}  />
	}
}

export class TabBasedContent extends AwrabetTabBasedContent {
}

export class LiveEventContent extends AwrabetLiveEventContent {
	render({eventId, sport, tournament}) {
		const event = LFeed.getEvent(eventId);
		const currentTab = this.getCurrentTab(event);
		const markets = this.getMarketsToDisplay(event)
		const odds = groupMarketsByName(markets);
		
		return <Fragment>
			<P.EventHeader {...{sport, category: null, tournament}} onClose={() => {window.history.back()}} />
			<P.EventName>{event.home} - {event.away}</P.EventName>
			<P.EventInfoRow>
				<P.EventInfoCell>{event.status.phase}</P.EventInfoCell>
				<P.EventInfoCell>{event.status.timer ? event.status.timer+"'" : 'LIVE'}</P.EventInfoCell>
			</P.EventInfoRow>
			<P.LiveEventNameLarge event={event} />
			<P.EventInfoRow>
				<a href="javascript:void(0);" onClick={() => this.setState({showTracker: !this.state.showTracker})} class="block w-full text-center p-2">
					<i class={"fa "+ (this.state.showTracker? 'fa-chevron-up' : 'fa-chevron-down')} />
				</a>
			</P.EventInfoRow>
			{!!event && !!this.state.showTracker && <LiveTrackerByEventPanel event={event} />}
			<P.TabsHScrollContainer>
				{this.extractTabs(event).map(tab => 
					<P.SingleEventTab selected={currentTab.id == tab.id} onClick={() => this.setState({currentTab: tab.id})}>
						{tab.name}
					</P.SingleEventTab>
				)}
			</P.TabsHScrollContainer>
			<P.EventMarketsMarketGroup>
				{odds.map((marketGroup, idx) => 
					<CollapsibleMarket key={currentTab.id+marketGroup.name} open={idx < 3} marketGroup={marketGroup} />
				)}
			</P.EventMarketsMarketGroup>
			<P.FakeSeparator />
		</Fragment>
	}
}

export class CollapsibleMarket extends AwrabetCollapsibleMarket {
	render({marketGroup}) {
		const marketGroupName = marketGroup.sub.length == 1 ? marketGroup.sub[0].name : marketGroup.name;
		return <P.MarketGroup>
			<P.MarketGroupHeader open={this.state.open} onClick={() => this.setState({open: !this.state.open, wasOpen: true})}>
				{marketGroupName}
			</P.MarketGroupHeader>
			{this.state.wasOpen && <P.MarketCollapsingElem open={this.state.open}>
				{marketGroup.sub.map(market => <P.MarketGroupOdds cols={Object.keys(market.sub).length}>
					{Object.values(market.sub).map(outcome => {
						return <P.MarketGroupOddButton 
								   outcome={outcome} 
								   selected={Ticket.hasLiveOdds(outcome.id)}
								   onClick={() => Ticket.toggleLiveOdds(outcome.id)} />
					})}
				</P.MarketGroupOdds>)}
			</P.MarketCollapsingElem>}
		</P.MarketGroup>
	}
}
